<section class="ai-section">
    <div class="container">
        <div class="card">
            <div class="page-header">
                <div>
                    <h3 class="page-title">LLM Providers</h3>
                    <p class="page-subtitle">API families the agents call. Keys are write-only and never shown.</p>
                </div>
                <div class="flex-spacer"></div>
                <button *ngIf="perms.has(P.providerCreate)" class="btn-primary btn-inline" (click)="openCreate()">
                    <i class="fa-solid fa-plus"></i> Add provider
                </button>
            </div>

            <div class="table-wrapper table-mobile-card">
                <table class="table" id="ai-providers-table">
                    <thead>
                        <tr>
                            <th>Code</th>
                            <th>Display name</th>
                            <th>Adapter</th>
                            <th>Base URL</th>
                            <th class="status-col">Enabled</th>
                            <th>API key</th>
                            <th class="actions-wide">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngIf="!loading && providers.length === 0">
                            <td colspan="100%">
                                <div class="no-data"><i class="fa-solid fa-plug"></i> No providers found</div>
                            </td>
                        </tr>
                        <tr *ngFor="let p of providers">
                            <td data-label="Code"><strong>{{ p.code }}</strong></td>
                            <td data-label="Display name">{{ p.displayName }}</td>
                            <td data-label="Adapter">
                                <span class="badge">{{ p.adapterType }}</span>
                                <div *ngIf="p.adapterType === 'ANTHROPIC'" class="muted">Phase 2: not enabled in v1</div>
                            </td>
                            <td data-label="Base URL" class="mono">{{ p.baseUrl }}</td>
                            <td data-label="Enabled" class="status-col">
                                <span [ngClass]="p.enabled ? 'status-active' : 'status-disabled'">{{ p.enabled ? 'Yes' : 'No' }}</span>
                            </td>
                            <td data-label="API key">
                                <span class="badge" [ngClass]="p.hasApiKey ? 'ok' : 'warn'">
                                    <i class="fa-solid" [ngClass]="p.hasApiKey ? 'fa-lock' : 'fa-triangle-exclamation'"></i>
                                    {{ p.hasApiKey ? 'Key set' : 'No key' }}
                                </span>
                            </td>
                            <td data-label="Actions" class="actions-wide">
                                <div class="actions-cell">
                                    <button *ngIf="perms.has(P.providerUpdate)" class="icon-btn edit" title="Edit" (click)="openEdit(p)">
                                        <i class="fa-solid fa-pen"></i>
                                    </button>
                                    <button *ngIf="perms.has(P.providerApiKey)" class="icon-btn create" title="Set API key" (click)="openKeyDialog(p)">
                                        <i class="fa-solid fa-key"></i>
                                    </button>
                                    <button *ngIf="perms.has(P.providerUpdate)" class="icon-btn view" [title]="p.enabled ? 'Disable' : 'Enable'" (click)="toggleEnabled(p)">
                                        <i class="fa-solid" [ngClass]="p.enabled ? 'fa-toggle-on' : 'fa-toggle-off'"></i>
                                    </button>
                                    <button *ngIf="perms.has(P.providerDelete)" class="icon-btn delete" title="Delete" (click)="remove(p)">
                                        <i class="fa-solid fa-trash"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</section>

<!-- Create / edit provider -->
<div *ngIf="editorOpen" class="dialog-overlay">
    <div class="dialog-card" role="dialog" aria-modal="true">
        <div class="dialog-header">
            <div>
                <h3>{{ editingId ? 'Edit provider' : 'Add provider' }}</h3>
                <p>OPENAI_COMPATIBLE serves OpenAI, DeepSeek, Groq, Together, Ollama and any compatible host.</p>
            </div>
            <button type="button" class="icon-btn back" (click)="closeEditor()"><i class="fa-solid fa-xmark"></i></button>
        </div>
        <form class="dialog-body" (ngSubmit)="save()">
            <div class="two-col">
                <div class="form-field">
                    <label for="pv-code">Code</label>
                    <input id="pv-code" name="code" [(ngModel)]="form.code" maxlength="40" placeholder="OPENAI" />
                </div>
                <div class="form-field">
                    <label for="pv-name">Display name</label>
                    <input id="pv-name" name="displayName" [(ngModel)]="form.displayName" maxlength="120" placeholder="OpenAI" />
                </div>
            </div>
            <div class="two-col">
                <div class="form-field">
                    <label for="pv-adapter">Adapter type</label>
                    <select id="pv-adapter" name="adapterType" [(ngModel)]="form.adapterType">
                        <option *ngFor="let t of adapterTypes" [ngValue]="t">{{ t }}</option>
                    </select>
                    <span class="hint" *ngIf="form.adapterType === 'ANTHROPIC'">The Anthropic adapter is phase 2; calls fail with "not enabled" in v1.</span>
                </div>
                <div class="form-field">
                    <label for="pv-url">Base URL</label>
                    <input id="pv-url" name="baseUrl" [(ngModel)]="form.baseUrl" maxlength="500" placeholder="https://api.openai.com/v1" />
                </div>
            </div>
            <label class="check-row"><input type="checkbox" name="enabled" [(ngModel)]="form.enabled" /> Enabled</label>
            <div *ngIf="formError" class="form-field"><span class="error-text">{{ formError }}</span></div>
            <div class="dialog-footer">
                <button type="button" class="btn-light" (click)="closeEditor()">Cancel</button>
                <button type="submit" class="btn-primary">Save</button>
            </div>
        </form>
    </div>
</div>

<!-- Set API key (write-only) -->
<div *ngIf="keyDialogFor" class="dialog-overlay">
    <div class="dialog-card narrow" role="dialog" aria-modal="true">
        <div class="dialog-header">
            <div>
                <h3>Set API key</h3>
                <p>{{ keyDialogFor.displayName }}: the key is stored encrypted and can never be read back.</p>
            </div>
            <button type="button" class="icon-btn back" (click)="closeKeyDialog()"><i class="fa-solid fa-xmark"></i></button>
        </div>
        <form class="dialog-body" (ngSubmit)="saveKey()" autocomplete="off">
            <div class="form-field">
                <label for="pv-key">API key</label>
                <div class="copy-row">
                    <input id="pv-key" name="apiKey" [type]="showKey ? 'text' : 'password'" [(ngModel)]="apiKey"
                        maxlength="4000" autocomplete="new-password" spellcheck="false" />
                    <button type="button" class="icon-btn view" [title]="showKey ? 'Hide' : 'Show'" (click)="showKey = !showKey">
                        <i class="fa-solid" [ngClass]="showKey ? 'fa-eye-slash' : 'fa-eye'"></i>
                    </button>
                </div>
                <span class="hint">{{ keyDialogFor.hasApiKey ? 'A key is set. Saving replaces it.' : 'No key is set yet.' }}</span>
            </div>
            <div class="dialog-footer">
                <button type="button" class="btn-light" (click)="closeKeyDialog()">Cancel</button>
                <button type="submit" class="btn-primary" [disabled]="!apiKey.trim()">Save key</button>
            </div>
        </form>
    </div>
</div>
